import { InterpreterOptions } from 'xstate'

export const commonFlowOptions: Partial<InterpreterOptions> = {
  devTools: process.env.NODE_ENV === 'development'
}
